// Build time configuration. Every value here is substituted literally by
// Bun.build's `define` (see apps/web/build.ts), so nothing reads
// `process` at runtime in the browser. The map defaults are keyless, the
// prototype must run with no configuration at all.

export const MAP_STREET_STYLE_URL: string = process.env.MAP_STREET_STYLE_URL as string;
export const MAP_SATELLITE_TILE_URL: string = process.env.MAP_SATELLITE_TILE_URL as string;
export const MAP_TERRAIN_TILE_URL: string = process.env.MAP_TERRAIN_TILE_URL as string;
export const MAP_ATTRIBUTION: string = process.env.MAP_ATTRIBUTION as string;

// Empty means "same origin", which is the deployed shape: the API is
// reverse proxied under the same host so cookies and the CSP stay simple.
export const API_URL: string = (process.env.API_URL as string) || "";

/**
 * PRODUCT DECISION, not a technical limit: this is an Indonesian travel
 * diary, so the map is Indonesia only. The camera opens on these bounds, it
 * cannot be panned outside them, and it cannot be zoomed out past the
 * country. Widening the product later is a one line change here.
 *
 * Order is [west, south, east, north], the order MapLibre's LngLatBounds and
 * `maxBounds` both take.
 */
export const INDONESIA_BOUNDS: [number, number, number, number] = [95.0, -11.1, 141.1, 6.1];

/**
 * Pan margin in degrees, added around whatever the country fit occupies at
 * the current viewport. Small on purpose: it exists so a pin sitting on the
 * very edge is still reachable, not so the map can wander into open ocean.
 *
 * The hard pan window CANNOT be a constant. A portrait phone fitting a wide
 * country necessarily sees more latitude than the country covers, and a fixed
 * latitude wall would force the map to zoom in to obey it, which is exactly
 * the "too zoomed in" bug. So the window is derived at runtime from the fit.
 */
export const INDONESIA_PAN_MARGIN_DEG = 0.75;

/**
 * Absolute floor, only a safety net. The REAL minimum zoom is computed at
 * runtime from these bounds at the current viewport size (see MapView): a
 * value that fills a 375px phone leaves half the world visible on a 1280px
 * desktop, so no single constant can be correct on both.
 */
export const INDONESIA_MIN_ZOOM = 3;

/** Padding used when the camera frames the country, in CSS pixels. */
export const INDONESIA_FIT_PADDING = 12;
